import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../../adapter-vue";
import { isH5 } from "../../../../utils/env";
import ToolbarItemContainer from "../toolbar-item-container/index.vue";
import EmojiPickerDialog from "./emoji-picker-dialog.vue";
import faceIcon from "../../../../assets/icon/face.png";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["insertEmoji", "dialogShowInH5", "dialogCloseInH5", "currentComponentID", "toggleComponent", "sendMessage"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var _currentConversation = ref();
    var container = ref();
    TUIStore.watch(StoreName.CONV, {
      currentConversation: function currentConversation(conversation) {
        _currentConversation.value = conversation;
      }
    });
    var onIconClick = function onIconClick(dialogRef) {
      if (!isH5) {
        emits("toggleComponent");
        return;
      }
      emits("dialogShowInH5", dialogRef.value);
    };
    var onDialogClose = function onDialogClose(dialogRef) {
      if (!isH5) {
        return;
      }
      emits("dialogCloseInH5", dialogRef.value);
    };
    var insertEmoji = function insertEmoji(emojiObj) {
      emits("insertEmoji", emojiObj);
    };
    var sendMessage = function sendMessage() {
      emits("sendMessage");
    };
    var onClose = function onClose() {
      var _container$value;
      container === null || container === void 0 || (_container$value = container.value) === null || _container$value === void 0 || _container$value.toggleDialogDisplay(false);
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(ToolbarItemContainer, {
        iconFile: _unref(faceIcon),
        title: "表情",
        onOnIconClick: onIconClick,
        onOnDialogClose: onDialogClose,
        ref_key: "container",
        ref: container
      }, {
        "default": _withCtx(function () {
          return [_createVNode(EmojiPickerDialog, {
            onInsertEmoji: insertEmoji,
            onSendMessage: sendMessage,
            onOnClose: onClose
          })];
        }),
        _: 1
      }, 8, ["iconFile"]);
    };
  }
});